import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Services.css'; // New CSS file

export default function Services() {
  const services = [
    {
      title: 'ArchViz - High quality',
      desc: 'The high quality of Arch-Viz is tailored to specific needs with a customized UX that showcases the points a customer wants across.',
      img: '/img/products/archviz-hq/1.jpg',
      link: '/services/archviz-hq',
    },
    {
      title: 'VR aided build',
      desc: 'VR aided build presents a unique opportunity to alleviate the construction process from the challenges that have existed for a long time.',
      img: '/img/products/vr-builder/1.jpg',
      link: '/services/vr-aided-build',
    },
  ];

  return (
    <>
      <Navbar />
      <div className="services-page">
        <h2 className="ssection-heading">What we do</h2>

        <div className="section-description">
          At SmartVizX, we work to change the way people consume information and view things around them. Through our immersive technologies, interactive virtual reality solutions and product visualizations; users get a new perspective and businesses make well-informed decisions.
          <br /><br />
          Take a look at how we have made dreams into reality.
        </div>

        <div className="service-grid">
          {services.map((service, index) => (
            <div className="service-card" key={index}>
              <a href={service.link}>
                <img src={service.img} alt={service.title} />
                <h4>{service.title}</h4>
                <p>{service.desc}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </>
  );
}
